import React, {useState, useEffect} from "react";
import { getDataResource } from "../../services/scpApi";
import Collapsible from "../collapsible/Collapsible";
import Bundle from "./Bundle";
import SaveButton from "../saveButton/SaveButton";
import { useSelector } from "react-redux";
import { current } from "@reduxjs/toolkit";



const BundleProgress = ({currentBundleProgress, updateBundleProgress, roadmap, setRoadmap, bundleData, setBundleData, refetchStudentData, loading}) => {

    const [bundleDataReady, setBundleDataReady] = useState(false);
    // const [successMessage, setSuccessMessage] = useState('');
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);
    const selectedSchool = useSelector(state => state.portalSelected.selectedSchool);

    console.log('BUNDLE DATA: ', bundleData);


    useEffect(() => {
        if (!selectedStudent || !selectedSchool || !currentBundleProgress) {
            return;
        }

        (async () => {
            let bundles = await getDataResource('maths-bundles');
            bundles = combineProgressWithBundleData(bundles, currentBundleProgress);

            setBundleData(bundles);
            setBundleDataReady(true);
        })();
    }, [currentBundleProgress])


    /**
     * Combine the template bundle data (no progress), with the pupils progress bundle data
     * 
     * @param {*} bundles 
     * @param {*} currentBundleProgress 
     * @returns {object}
     */
    const combineProgressWithBundleData = (bundles, currentBundleProgress) => {
        Object.keys(currentBundleProgress).map((levelKey) => {
            Object.keys(currentBundleProgress[levelKey]).map((bundleKey) => {
                try {
                    bundles[levelKey][bundleKey]['completed'] = currentBundleProgress[levelKey][bundleKey]['completed'];

                    if (currentBundleProgress[levelKey][bundleKey]['lessons'] && Object.keys(currentBundleProgress[levelKey][bundleKey]['lessons']).length > 0) {
                        bundles[levelKey][bundleKey]['lessons'] = currentBundleProgress[levelKey][bundleKey]['lessons'];
                    }

                    if (currentBundleProgress[levelKey][bundleKey]['assessments'] && Object.keys(currentBundleProgress[levelKey][bundleKey]['assessments']).length > 0) {
                        bundles[levelKey][bundleKey]['assessments'] = currentBundleProgress[levelKey][bundleKey]['assessments'];
                    }

                } catch (error) {
                    console.log(error);
                }
            });
        });

        return bundles;
    };


    /**
     * Prepare bundlekey for display
     * 
     * @param {string} bundleKey 
     * @returns {string}
     */
    const convertBundleKeyToTitle = (bundleKey) => {
        let bundleTitle = bundleKey.replace(/-/g, ' ');
        return bundleTitle.charAt(0).toUpperCase() + bundleTitle.slice(1);
    }

    /**
     * Update the bundle state with new single bundle status change
     * 
     * @param {string} updatedLevelKey 
     * @param {string} updatedBundleKey 
     * @param {boolean} status 
     */
    const updateStatus = (updatedLevelKey, updatedBundleKey, status) => {

        let updatedBundleData = {...bundleData};

        updatedBundleData[updatedLevelKey][updatedBundleKey]['completed'] = status;

        setBundleData(updatedBundleData);
    }

    const handleUpdate = async () => {
        try {
            await updateBundleProgress(bundleData);
        } catch (error) {
            console.error("Failed to update:", error);
        }
    };

    // Update roadmap state with bundle data
    const updateRoadmap = (levelKey, bundleKey) => {
        let newRoadmap = [...roadmap];

        // Ensure sort is inline with order property before adding or removing items
        newRoadmap.sort((a, b) => {
            return a.order - b.order;
        });

        // Add the new roadmap bundle into the roadmap array state at the end (also unset if it already exists)
        const exists = newRoadmap.findIndex(
            b => b.levelKey === levelKey && b.bundleKey === bundleKey
        );

        // remove if it exists
        if (exists !== -1) {
            newRoadmap = newRoadmap.filter((_, i) => i !== exists);
        }
        
        // append new item
        else {
            newRoadmap.push({ levelKey, bundleKey });
        }

        // iterate through to set the order property
        newRoadmap.forEach((roadmap, i) => {
            roadmap.order = i + 1;
        });

        setRoadmap(newRoadmap);
    };


    return (
        <>
            {bundleDataReady && bundleData && bundleData['level-1'] ? (
                <>
                    <div className="bundle-progress-cont">
                        {Object.keys(bundleData).map((levelKey) => (
                            <div className="level-cont-outer" key={levelKey}>
                                <Collapsible title={convertBundleKeyToTitle(levelKey)} key={levelKey} open={true}>
                                    <div className="level-cont">
                                        {Object.keys(bundleData[levelKey]).map((bundleKey) => (
                                            <Bundle 
                                                key={`${levelKey}-${bundleKey}`}
                                                levelKey={levelKey}
                                                bundleKey={bundleKey} 
                                                completed={bundleData[levelKey][bundleKey]['completed']} 
                                                label={bundleData[levelKey][bundleKey]['label']} 
                                                updateStatus={(levelKey, bundleKey, status) => updateStatus(levelKey, bundleKey, status)}
                                                updateRoadmap={updateRoadmap}
                                                roadmap={roadmap}
                                            />
                                        ))}

                                    </div>
                                </Collapsible>
                            </div>
                        ))}
                    </div>
                    <SaveButton
                        save={handleUpdate}
                        loading={loading}
                        textUpdate="Update Bundle Progress"
                        textUpdateLoading="Updating..."
                        textUpdateSuccess="Updated"
                        textUpdateError="Error"
                        isUpdating={loading}
                    />
                </>
            ) : (
                <p>Loading...</p>
            )}
        </>
    )
}

export default BundleProgress;
